export enum channelNames {
  'chat' = 'Web Messaging',
  'twilio' = 'SMS',
  'twilio-whatsapp' = 'WhatsApp',
  'facebook' = 'Facebook',
  'twitter' = 'Twitter',
  'abc' = 'Apple Messages for Business',
  'custom' = 'Client Channel API',
  'vonage-sms' = 'SMS',
  'vonage-whatsapp' = 'WhatsApp',
  'sdk_mobile' = 'Mobile Messaging SDK',
  'combined_messaging' = 'Combined Messaging Channel',
  'agent_trainer' = 'GenAI Agent Trainer',
}

export const FBErrorMessages: any = {
  FBA1: 'Facebook authorization failed, please try again. If the problem persists, contact support',
  FBA2: 'Facebook authorization failed, please try again. If the problem persists, contact support',
  FBA3: 'Facebook authorization failed, please try again. If the problem persists, contact support',
  FBA4: 'The Facebook administrator for this page is already connected to another Pega instance',
  FBA5: 'No Facebook pages were selected for authorization',
};

export const TwitterErrorMessages: any = {
  TWTA1: 'Twitter account authorization failed, please try again. If the problem persists, contact support',
  TWTA2: 'Twitter account authorization denied by user',
  TWTA3: 'Twitter account authorization failed, please try again. If the problem persists, contact support',
  TWTA4: 'Twitter account authorization failed, please try again. If the problem persists, contact support',
  TWTA5: 'The Twitter account is already connected to another Pega instance',
};

export const ABCErrorMessages: any = {
  ABCA1: 'The Apple Messages for Business account is already connected to another Pega instance',
  ABCA2: 'Mandatory field missing',
};

export const SMSErrorMessages: any = {
  TWLA1: 'The Twilio SMS account is already connected to another Pega instance',
  TWLA2: 'Invalid/missing mandatory field',
};

export const WhatsAppErrorMessages: any = {
  WTPA1: 'The Twilio WhatsApp account is already connected to another Pega instance',
  WTPA2: 'Invalid/missing mandatory field',
};

export enum AgentTrainerTabNames {
  SimulationConfiguration = 'Simulation configuration',
  ConnectionAndGenAI = 'Connection and genAI',
  LiveSimulation = 'Live simulation',
  SimulationHistory = 'Simulation history',
  Personas = 'Personas',
  AgentFeedback = 'Agent feedback',
}

export enum OpenAIHost {
  OpenAI = 'OpenAI',
  Azure = 'Azure',
  Pega = 'Pega GenAI',
}

export const AzureModels = [
  {
    label: 'GPT 3.5 Turbo',
    id: 'gpt-35-turbo',
  },
  {
    label: 'GPT 4',
    id: 'gpt-4',
  },
  {
    label: 'GPT 4 32k',
    id: 'gpt-4-32k',
  },
  {
    label: 'GPT 3.5 Turbo 16k',
    id: 'gpt-35-turbo-16k',
  },
];

export const OpenAIModels = [
  {
    label: 'GPT 4 2023-06-13',
    id: 'gpt-4-0613',
  },
  {
    label: 'GPT 4',
    id: 'gpt-4',
  },
  {
    label: 'GPT 4 2023-03-1',
    id: 'gpt-4-0314',
  },
  {
    label: 'GPT 3.5 Turbo 2023-06-13',
    id: 'gpt-3.5-turbo-16k-0613',
  },
  {
    label: 'GPT 3.5 Turbo 16k',
    id: 'gpt-3.5-turbo-16k',
  },
  {
    label: 'GPT 3.5 Turbo 2023-03-01',
    id: 'gpt-3.5-turbo-0301',
  },
];
export enum CustomerStatus {
  Initializing = 'Initializing',
  ConnectedToChatbot = 'Connected to chatbot',
  WaitingInQueue = 'Waiting in queue',
  ConnectedToAgent = 'Connected to agent',
  Resolved = 'Resolved',
}

export const ReleaseNotesLink =
  'https://docs.pega.com/bundle/platform/page/platform/release-notes/conversational-channels/whats-new-digital-messaging.html';

export const MaxNumberOfCustomers = 150;

export const LanguageLocalizationLink =
  'https://docs.pega.com/bundle/platform/page/platform/conversational-channels/enabling-real-time-translation-web-messaging.html';

export const RealTimeTranslationsLink =
  'https://docs.pega.com/bundle/platform/page/platform/conversational-channels/real-time-translation-web-messaging.html';

export const GoogleApiKeyGenLink =
  'https://docs.pega.com/bundle/platform/page/platform/conversational-channels/configuring-google-translate-api-key.html';

export enum VerticalTemplateOption {
  Default = 'default',
  FinancialServices = 'financial_services',
  Communications = 'communications',
  Insurance = 'insurance',
  Healthcare = 'healthcare',
}

export enum ActionsPopoverFlow {
  Scenario = 'scenario',
  Feedback = 'feedback',
  Persona = 'persona',
  FeedbackWebhook = 'webhook',
}

export enum FeedbackResponseFormat {
  IntegerScore = 'Integer score',
  GradeRating = 'Grade rating',
  Summary = 'Summary',
  BulletPoints = 'Bullet points',
}

export const FeedbackResponseData = ['Integer score', 'Grade rating', 'Summary', 'Bullet points'];

export const ErrorDashboardLink =
  'https://docs.pega.com/bundle/customer-service/page/customer-service/constellation-implementation/chat-messaging/error-dashboard.html';
